module.exports = __webpack_public_path__ + "static/media/Begleitschreiben_AnkaufperPost_DE.d5d69a35.pdf";